import { styled } from 'solid-styled-components';
import theme from '../../../style/theme';

export const StyledMenuRightArea = styled.div`
    background-color: ${theme.palette.white};
    height: 100%;
`;
